// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICountryResponseDto } from './ICountryResponseDto';
import {
    ICountryResponseDtoFromJSON,
    ICountryResponseDtoFromJSONTyped,
    ICountryResponseDtoToJSON,
    ICountryResponseDtoToJSONTyped,
} from './ICountryResponseDto';
import type { IStateResponseDto } from './IStateResponseDto';
import {
    IStateResponseDtoFromJSON,
    IStateResponseDtoFromJSONTyped,
    IStateResponseDtoToJSON,
    IStateResponseDtoToJSONTyped,
} from './IStateResponseDto';

/**
 * 
 * @export
 * @interface IPaymentAddressResponseDto
 */
export interface IPaymentAddressResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPaymentAddressResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressResponseDto
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressResponseDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressResponseDto
     */
    line3?: string;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressResponseDto
     */
    line4?: string;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressResponseDto
     */
    city?: string;
    /**
     * 
     * @type {IStateResponseDto}
     * @memberof IPaymentAddressResponseDto
     */
    state?: IStateResponseDto;
    /**
     * 
     * @type {ICountryResponseDto}
     * @memberof IPaymentAddressResponseDto
     */
    country?: ICountryResponseDto;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressResponseDto
     */
    zipcode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPaymentAddressResponseDto
     */
    validated?: boolean;
}

/**
 * Check if a given object implements the IPaymentAddressResponseDto interface.
 */
export function instanceOfIPaymentAddressResponseDto(value: object): value is IPaymentAddressResponseDto {
    return true;
}

export function IPaymentAddressResponseDtoFromJSON(json: any): IPaymentAddressResponseDto {
    return IPaymentAddressResponseDtoFromJSONTyped(json, false);
}

export function IPaymentAddressResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentAddressResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'line4': json['line4'] == null ? undefined : json['line4'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : IStateResponseDtoFromJSON(json['state']),
        'country': json['country'] == null ? undefined : ICountryResponseDtoFromJSON(json['country']),
        'zipcode': json['zipcode'] == null ? undefined : json['zipcode'],
        'validated': json['validated'] == null ? undefined : json['validated'],
    };
}

export function IPaymentAddressResponseDtoToJSON(json: any): IPaymentAddressResponseDto {
    return IPaymentAddressResponseDtoToJSONTyped(json, false);
}

export function IPaymentAddressResponseDtoToJSONTyped(value?: IPaymentAddressResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'line4': value['line4'],
        'city': value['city'],
        'state': IStateResponseDtoToJSON(value['state']),
        'country': ICountryResponseDtoToJSON(value['country']),
        'zipcode': value['zipcode'],
        'validated': value['validated'],
    };
}

